import { render, staticRenderFns } from "./FundAllocation.vue?vue&type=template&id=6a529b9c&scoped=true&"
import script from "./FundAllocation.vue?vue&type=script&lang=js&"
export * from "./FundAllocation.vue?vue&type=script&lang=js&"
import style0 from "./FundAllocation.vue?vue&type=style&index=0&id=6a529b9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a529b9c",
  null
  
)

export default component.exports